import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import ProgessiMissions from "../../../shared/components/Freelance/ProgessiMissions.jsx"
import Positionings from "../../../shared/components/Freelance/Positionings.jsx"
import FreelancePage from "../../../shared/components/Styled/Containers/FreelancePage.jsx"


export default class PositioningsAndProgessiMissions extends PureComponent {
  static propTypes = {
    user: PropTypes.object.isRequired,
    freelance: PropTypes.object.isRequired,
  }

  render() {
    const {freelance, user, isAdmin} = this.props

    return (
      <FreelancePage>
        <h2 className="text-center mb-4">Suivi missions Progessi</h2>
        <ProgessiMissions user={user}/>

        <h2 className="text-center mb-4 mt-5">Positionnements</h2>
        <Positionings isAdmin={isAdmin} positionings={freelance.positionings}/>
      </FreelancePage>
    )
  }
}
